export const UNASSIGNED_RESOURCE_ID = "unassigned";

export function normalizeActivityAssignees(activity) {
  const source = activity?.assignees || activity?.work_order_assignees || [];
  if (!Array.isArray(source)) return [];

  return source
    .map((assignee) => ({
      type: assignee.type || assignee.assignee_type,
      // Concrete work-order rows contain both:
      //   id          -> work_order_assignees primary key
      //   assignee_id -> recipient/contact primary key
      // Calendar resources are keyed by the latter.
      id: Number(assignee.assignee_id ?? assignee.id),
      assignment_role:
        assignee.assignment_role || assignee.role || "assignee",
      name:
        assignee.name ||
        assignee.assignee_name ||
        [assignee.first_name, assignee.last_name].filter(Boolean).join(" ") ||
        assignee.email ||
        "",
    }))
    .filter(
      (assignee) =>
        ["recipient", "contact"].includes(assignee.type) &&
        Number.isInteger(assignee.id) &&
        assignee.id > 0
    );
}

export function teamResourceIdsForActivity(activity) {
  const recipientIds = normalizeActivityAssignees(activity)
    .filter(
      (assignee) =>
        assignee.type === "recipient" &&
        assignee.assignment_role !== "owner"
    )
    .map((assignee) => String(assignee.id));

  return recipientIds.length
    ? [...new Set(recipientIds)]
    : [UNASSIGNED_RESOURCE_ID];
}

export function groupActivitiesByResources(
  resources,
  activities,
  getResourceIds
) {
  const grouped = {};
  (resources || []).forEach((resource) => {
    grouped[String(resource.id)] = [];
  });

  (activities || []).forEach((activity) => {
    const resourceIds = getResourceIds(activity) || [];
    [...new Set(resourceIds.map(String))].forEach((resourceId) => {
      if (grouped[resourceId]) grouped[resourceId].push(activity);
    });
  });

  return grouped;
}

export function replaceDraggedRecipient(
  assignees,
  sourceRecipientId,
  targetRecipientId
) {
  const sourceId = String(sourceRecipientId || "");
  const targetId = Number(targetRecipientId);
  const normalized = normalizeActivityAssignees({ assignees });
  const next = normalized.filter(
    (assignee) =>
      !(
        assignee.type === "recipient" &&
        assignee.assignment_role !== "owner" &&
        String(assignee.id) === sourceId
      )
  );

  if (
    Number.isInteger(targetId) &&
    targetId > 0 &&
    !next.some(
      (assignee) =>
        assignee.type === "recipient" && assignee.id === targetId
    )
  ) {
    next.push({
      type: "recipient",
      id: targetId,
      assignment_role: "assignee",
      name: "",
    });
  }

  return next.map(({ type, id, assignment_role }) => ({
    type,
    id,
    assignment_role,
  }));
}

export function isActivityOverdue(activity, today) {
  const scheduledDate = String(
    activity?.scheduledDate || activity?.date || ""
  ).slice(0, 10);
  const status = String(activity?.status || "new").toLowerCase();
  return (
    Boolean(scheduledDate) &&
    scheduledDate < today &&
    !["completed", "closed"].includes(status)
  );
}
